window.BASEURL = document.location.origin + '/json/';
window.REDIRECT_BASEURL = document.location.origin + '/';
window.FILE_MANAGER_URL = document.location.origin + '/laravel-filemanager';
window.CSRFTOKEN = $('#csrf-token').attr('content');
window.CURRENT_ROUTE_NAME = $('#current_route_name').attr('content');
window.redirectTime = 2500;
